import React, { Fragment, useState } from 'react';
import { CalendarIcon } from 'cokitchen-icons';
import StatusColor from 'components/status-badge';
import { ENUM_DEAL_STATUS } from 'utils/enums';
import { ReactComponent as ThreeDotsIcon } from 'assets/icons/threedots.svg';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { Link, useSearchParams } from 'react-router-dom';
import { DealType } from 'models/deals.model';
import moment from 'moment';
import DeleteDealModal from 'components/modals/delete-deal-modal';
import DuplicateDealModal from 'components/modals/duplicate-deal';

const DealCard = ({ deal, handleDelete }: { deal: DealType; handleDelete: () => void }) => {
  const [dealStatus] = useSearchParams();
  const [show, setShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCokitchenModal, setShowCokitchenModal] = useState(false);

  const activeStatus = (dealStatus.get('dealStatus') ??
    ENUM_DEAL_STATUS.All.toLowerCase()) as string;

  const status =
    activeStatus === ENUM_DEAL_STATUS.Upcoming.toLowerCase()
      ? ENUM_DEAL_STATUS.Upcoming
      : activeStatus === ENUM_DEAL_STATUS.Active.toLowerCase()
      ? ENUM_DEAL_STATUS.Active
      : ENUM_DEAL_STATUS.Expired;

  const imgSrc = deal.images[0] || '';
  return (
    <Fragment>
      <div className='rounded-lg border border-gray-1/60 drop-shadow-lg shadow-sm group'>
        <div className='w-full h-32 relative rounded-lg'>
          <img
            src={imgSrc}
            alt='Deal card image'
            className='w-full object-cover aspect-video h-full rounded-lg'
          />
          <span className='bg-black/30 w-full h-full absolute inset-0 rounded-lg'></span>
          {activeStatus === ENUM_DEAL_STATUS.All.toLowerCase() ? null : (
            <span className='absolute bottom-3 left-2 transition-all'>
              <StatusColor
                status={status}
                wrapperClassName='p-0.5 !px-2 !bg-gray-1'
                className='text-xs'
              />
            </span>
          )}

          <Dropdown
            placement='top-end'
            visible={show}
            onClickOutside={() => setShow(false)}
            content={
              <button
                onClick={() => setShow(true)}
                className='drop-shadow-xl bg-black/50 rounded-full p-1 inline-block absolute top-2 opacity-20 group-hover:opacity-100 right-1 transition-all'>
                <ThreeDotsIcon className='w-4 h-4' />
              </button>
            }>
            <DropdownList className='drop-shadow-lg !w-24  text-gray-6 font-medium text-xs block'>
              <DropdownItem
                className='text-xs'
                onClick={() => {
                  setShow(false);
                  setShowCokitchenModal(true);
                }}>
                Duplicate Deal
              </DropdownItem>
              <Link to={`/deals/${deal.id}/edit`}>
                <DropdownItem className='text-xs'>Edit</DropdownItem>
              </Link>
              <DropdownItem
                className='text-xs'
                onClick={() => {
                  setShow(false);
                  setShowDeleteModal(true);
                }}>
                Delete
              </DropdownItem>
            </DropdownList>
          </Dropdown>
        </div>
        <div className='mx-3 my-4'>
          <div className='flex items-center gap-3'>
            <img src={imgSrc} alt='Brand image' className='w-8 h-8 rounded-full' />
            <div>
              <h3 className='font-semibold text-base text-gray-6'>
                {deal.discount_code.toUpperCase()}
              </h3>
              <p className='text-xs text-gray-8/80 font-semibold '>{deal.title}</p>
            </div>
          </div>
          <p className='flex items-center gap-2 text-xs mt-4 text-gray-8 font-medium'>
            <span className='flex items-center gap-1'>
              <CalendarIcon />
              {moment(deal.to_expire_time, 'HH:mm:ss').format('hh:mm:ss A')}
            </span>
            <span className='w-1 h-1 rounded-full bg-gray-6'></span>
            <span>{moment(deal.to_expire_date, 'YYYY-MM-DD').format('MMM Do, YYYY')}</span>
          </p>
        </div>
      </div>
      {showDeleteModal && (
        <DeleteDealModal
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          handleDelete={handleDelete}
          id={deal.id}
          code={deal.discount_code}
        />
      )}
      {showCokitchenModal && (
        <DuplicateDealModal
          isOpen={showCokitchenModal}
          onClose={() => setShowCokitchenModal(false)}
          deal={deal}
        />
      )}
    </Fragment>
  );
};
export default DealCard;
